import { z } from 'zod';

/**
 * Valeurs persistées dans `casediscovery_conversations.source_system`.
 *
 * - `hector_v3` : agent d'édition, écrit depuis l'add-in Word
 * - `hector_case_discovery_v3` : agent case discovery, écrit depuis legalworkspace
 * - `case_discovery` : valeur legacy pré-V3 — à traiter comme Workspace côté UI
 */
export const SourceSystemSchema = z.enum([
  'hector_v3',
  'hector_case_discovery_v3',
  'case_discovery',
]);
export type SourceSystem = z.infer<typeof SourceSystemSchema>;

/** Kind canonique utilisé côté UI — replie la valeur legacy sur 'workspace'. */
export type SourceKind = 'word' | 'workspace';

/**
 * Normalise la provenance pour l'UI. Tolérant aux valeurs inconnues, null
 * ou undefined : n'importe quoi d'autre que `'hector_v3'` retombe sur
 * 'workspace' (fallback sûr — aucune conversation Word ne peut avoir un
 * source_system manquant en pratique).
 */
export const sourceKindOf = (s: SourceSystem | string | null | undefined): SourceKind => {
  return s === 'hector_v3' ? 'word' : 'workspace';
};
